export default function EFHouse() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
            <path
                d="M6.22266 44.3331H9.33377M49.7782 44.3331H46.6671M9.33377 44.3331V24.8887H46.6671V44.3331M9.33377 44.3331H23.3338M46.6671 44.3331H23.3338M16.3338 14.7776L7.00043 26.8331M16.3338 14.7776H18.6671M16.3338 14.7776L24.1115 24.8887H23.3338V44.3331M49.3893 26.8331L38.8893 14.7776H31.5004M24.1115 14.7776L31.8893 24.8887M24.1115 14.7776H31.5004M24.1115 14.7776H18.6671M31.5004 14.7776L39.6671 24.8887M18.6671 14.7776V11.6665C18.6671 11.2369 18.3189 10.8887 17.8893 10.8887H14.0004C13.5709 10.8887 13.2227 11.2369 13.2227 11.6664V19.0553"
                stroke="white"
                strokeOpacity="0.92"
                strokeWidth="1.55556"
                strokeLinecap="round"
            />
            <path
                d="M35 44.3331V34.9998C35 33.2816 36.3929 31.8887 38.1111 31.8887V31.8887C39.8293 31.8887 41.2222 33.2816 41.2222 34.9998V44.3331"
                stroke="white"
                strokeOpacity="0.92"
                strokeWidth="1.55556"
            />
            <circle cx="16.3338" cy="34.9998" r="3.11111" stroke="white" strokeOpacity="0.92" strokeWidth="1.55556" />
        </svg>
    );
}
